/**
 * What a platform accepts for a format, as opposed to the canvas we create it at.
 *
 * The property list is a closed registry rather than free keys: a consumer (the picker, a future
 * asset validator, the CSV import) can only rely on a property it knows the shape of, and a typo'd
 * key that silently carried a value would read as a spec nobody can check.
 */
const IMAGE_PROPERTIES = {
    'dimensions.min': 'size',
    'dimensions.max': 'size',
    'dimensions.recommended': 'size',
    'aspectRatio.accepted': 'ratioList',
    'aspectRatio.recommended': 'ratio',
    fileFormats: 'stringList',
    colorSpace: 'text',
    transparency: 'transparency',
    'fileSize.max': 'number',
    cropping: 'text',
    safeZone: 'margins',
};
const VIDEO_PROPERTIES = {
    'dimensions.min': 'size',
    'dimensions.max': 'size',
    'dimensions.recommended': 'size',
    'aspectRatio.accepted': 'ratioList',
    'aspectRatio.recommended': 'ratio',
    containers: 'stringList',
    codec: 'stringList',
    'codec.profile': 'text',
    colorSpace: 'text',
    pixelFormat: 'text',
    chromaSubsampling: 'text',
    'fileSize.max': 'number',
    'duration.min': 'number',
    'duration.max': 'number',
    'frameRate.accepted': 'numberSet',
    'frameRate.fixedRequired': 'boolean',
    'bitrate.min': 'number',
    'bitrate.max': 'number',
    'bitrate.recommended': 'number',
    'audio.codec': 'stringList',
    'audio.bitrate': 'number',
    'audio.sampleRate': 'number',
    'audio.channels': 'number',
    cropping: 'text',
    safeZone: 'margins',
    'thumbnail.required': 'boolean',
    'thumbnail.dimensions.recommended': 'size',
    'thumbnail.aspectRatio.recommended': 'ratio',
    'thumbnail.fileFormats': 'stringList',
    'thumbnail.fileSize.max': 'number',
};
/**
 * Numbers are stored in one base unit per property - bytes, seconds, kbps, Hz, fps - so a value
 * never carries a unit that a consumer has to parse back out.
 */
export const SPEC_PROPERTIES = {
    image: IMAGE_PROPERTIES,
    video: VIDEO_PROPERTIES,
};
export const SPEC_REQUIREMENTS = ['required', 'recommended', 'accepted'];
export const SPEC_SCOPES = ['placement', 'general_upload', 'api'];
export const TRANSPARENCY_VALUES = ['supported', 'not_supported', 'flattened', 'required'];
export const TEXT_LIMIT_FIELDS = [
    'headline',
    'primaryText',
    'description',
    'callToAction',
    'displayUrl',
    'brandName',
    'adName',
];
